import siteData from "../data/siteData.json";

function UpcomingProjects() {
  const { upcomingProjects } = siteData;

  return (
    <>
      <header>
        <div id="carouselExampleCaptions" className="carousel slide hm-slider">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={siteData.heroBanner} className="d-block w-100" alt="..." />
            </div>
          </div>
        </div>
      </header>

      <section className="page-title mt-2">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="about-head text-left">
                <h1>OUR PROJECTS</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="project pt-5 pb-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="title">
                <h1>Upcoming Projects</h1>
              </div>
            </div>
            <div className="col-md-12 mb-4">
              <div
                className="alert alert-info"
                style={{ background: "#e8f4f8", borderLeft: "4px solid #695041" }}
              >
                <h4 style={{ color: "#695041", marginBottom: "10px" }}>
                  <i className="fa fa-clock-o"></i> Exciting New Projects Coming Soon!
                </h4>
                <p style={{ margin: 0 }}>
                  We are currently working on several new premium residential and commercial
                  projects in Mumbai. Stay tuned for more updates!
                </p>
              </div>
            </div>

            {upcomingProjects.map((project) => (
              <div className="col-md-4 mt-2 mb-3" key={project.id}>
                <div className="project-mas hover-shadow">
                  <div className="image-effect-one">
                    <img src={project.image} alt={project.name} />
                    <span className={`badge-status ${project.badgeClass}`}>
                      {project.badge}
                    </span>
                    <span
                      className="map-icon-btn"
                      data-bs-toggle="modal"
                      data-bs-target={`#${project.mapModalId}`}
                    >
                      <i className="fa fa-map-marker"></i>
                    </span>
                  </div>
                  <div className="project-info">
                    <h4>{project.name}</h4>
                    <p className="project-desc">{project.desc}</p>
                    <div className="project-details">
                      <div className="detail-item">
                        <i className={`fa ${project.configIcon}`}></i>{" "}
                        <strong>{project.config}</strong>
                      </div>
                      <div className="detail-item">
                        <i className="fa fa-map-marker"></i>{" "}
                        <strong>{project.location}</strong>
                      </div>
                      <div className="detail-item">
                        <i className="fa fa-calendar"></i>{" "}
                        <strong>{project.possession}</strong>
                      </div>
                    </div>
                    <div className="rera-info">
                      <span className="rera-badge">RERA: {project.rera}</span>
                    </div>
                    <div className="project-cta">
                      <button className="btn-enquire">
                        <a className="read">ENQUIRE NOW</a>
                      </button>
                      <button className="btn-visit">
                        <a
                          href="/pdf/Brochure.pdf"
                          target="_blank"
                          rel="noreferrer"
                          className="read"
                        >
                          <i className="fa fa-download"></i> DOWNLOAD
                        </a>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {upcomingProjects.map((project) => (
        <div
          className="modal fade map-modal"
          id={project.mapModalId}
          tabIndex="-1"
          aria-hidden="true"
          key={project.mapModalId}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{project.mapTitle}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <iframe
                  src={project.mapEmbed}
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`${project.name} Location Map`}
                ></iframe>
                <div className="location-info">
                  <p>
                    <i className="fa fa-map-marker"></i>{" "}
                    <strong>Address:</strong> {project.mapAddress}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default UpcomingProjects;